import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '#environments';
import { ErrorReductionTool, ErrorReductionToolCreateUpdate } from '#models';

@Injectable({
  providedIn: 'root',
})
export class ErrorReductionToolService {
  private _httpClient = inject(HttpClient);

  getByBusinessUnitId(businessUnitId: number): Observable<ErrorReductionTool[]> {
    return this._httpClient.get<ErrorReductionTool[]>(
      `${environment.apiUrl}/error-reduction-tools?businessUnitId=${businessUnitId}`
    );
  }

  create(businessUnitId: number, dto: ErrorReductionToolCreateUpdate): Observable<ErrorReductionTool> {
    return this._httpClient.post<ErrorReductionTool>(
      `${environment.apiUrl}/business-units/${businessUnitId}/error-reduction-tools`,
      dto
    );
  }

  rename(id: number, dto: ErrorReductionToolCreateUpdate): Observable<ErrorReductionTool> {
    return this._httpClient.put<ErrorReductionTool>(`${environment.apiUrl}/error-reduction-tools/${id}`, dto);
  }

  delete(id: number): Observable<void> {
    return this._httpClient.delete<void>(`${environment.apiUrl}/error-reduction-tools/${id}`);
  }
}
